<template>
  <Card :class="$style.authNSimulationCard">
    <template #header>
      <HeadingMedium>
        {{ title }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <div
        :class="$style.cardBody"
      >
        <ParagraphBody>
          {{ content }}
        </ParagraphBody>
      </div>
    </template>
    <template v-slot:footer>
      <footer
        :class="$style.cardFooter"
      >
        <DropdownActions
          buttonText="Guided Setup"
          :class="$style.actionDropdown"
          :items="mainActionItems"
        />
        <ButtonLink
          :class="$style.buttonLink"
          text="View Simulation"
          @click="onViewDemoClickLink"
        />
      </footer>
    </template>
  </Card>
</template>

<script>
import {
  ButtonLink,
  Card,
  DropdownActions,
  HeadingMedium,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import SimulationModal from 'client/components/Modal/SimulationModal.vue';

import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const { DropdownMenuItem } = Types;
const authNPoliciesRoute = ItemTypeRoutes[ItemTypeConsts.authNPolicies];

export default {
  name: 'AuthNSimulationCard',

  EventHelper,
  ModalEventBus,
  Util,

  components: {
    ButtonLink,
    Card,
    DropdownActions,
    HeadingMedium,
    ParagraphBody,
  },

  props: {
    content: {
      type: String,
      default: () => '',
    },
    guideName: {
      type: String,
      default: () => '',
    },
    iframeSrc: {
      type: String,
      default: () => '',
    },
    simulationUrl: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    mainActionItems() {
      return [
        DropdownMenuItem({
          click: () => {},
          isDisabled: true,
          text: 'Select resource for policy',
        }),
        DropdownMenuItem({
          separator: true,
        }),
        DropdownMenuItem({
          click: () => this.onGuidedSetupMenuClick('User Portal', 'userportal'),
          text: 'User Portal',
        }),
        DropdownMenuItem({
          click: () => this.onGuidedSetupMenuClick('SSO Applications', 'application'),
          text: 'SSO Applications',
        }),
        DropdownMenuItem({
          click: () => this.onGuidedSetupMenuClick('JumpCloud LDAP', 'ldap'),
          text: 'JumpCloud LDAP',
        }),
      ];
    },
  },

  methods: {
    emitSegmentEvent({ type, description, section }) {
      this.$options.EventHelper[type]({
        [eventProperties.location]: eventLocations.conditionalPoliciesPage,
        [eventProperties.description]: description,
        [eventProperties.section]: section,
      });
    },

    onGuidedSetupMenuClick(name, type) {
      this.emitSegmentEvent({
        description: `${name} Guided Setup Started`,
        type: 'triggerButtonClicked',
        section: `Auth N Policies ${this.title} Demo Card Dropdown`,
      });

      this.routeToNewWithType(type);
    },

    onViewDemoClickLink() {
      this.emitSegmentEvent({
        description: `${this.title} Demo Started`,
        type: 'triggerButtonClicked',
        section: `Auth N Policies ${this.title} Demo Card`,
      });

      this.$options.ModalEventBus.open({
        component: SimulationModal,
        isLargeModal: true,
        componentProps: {
          iframeSrc: this.iframeSrc,
          simulationUrl: this.simulationUrl,
        },
      });
    },

    routeToNewWithType(type) {
      this.$options.Util.redirect(`${authNPoliciesRoute}/new?type=${type}&guide=${this.guideName}`);
    },
  },
};
</script>

<style scoped module>
.authNSimulationCard {
  display: flex;
  flex-flow: column;
}

.authNSimulationCard /deep/ div:nth-child(2) {
  flex: 1;
  padding-top: var(--jc-spacer-medium);
}

.actionDropdown /deep/ li:nth-child(2) {
  padding: 0;
}

.actionDropdown /deep/ ul {
  width: 230px;
}

.cardFooter {
  display: flex;
}

.buttonLink {
  margin-left: var(--jc-spacer-medium);
}
</style>
